import { ChevronDownIcon } from "@heroicons/react/24/outline";

const SelectField = ({
    value,
    onChange,
    options = [],
    placeholder,
}) => {
    return (
        <div className="relative w-full">
            <select
                value={value}
                onChange={onChange}
                className="w-full px-4 py-3 text-black border appearance-none  dark:text-white bg-bg-light-primary dark:bg-bg-dark-primary border-border-light dark:border-border-dark rounded-xl focus:outline-none focus:ring focus:ring-primary-light dark:focus:ring-primary"
            >
                <option value="">{placeholder}</option>

                {options.map(opt => (
                    <option key={opt.value} value={opt.value}>
                        {opt.label}
                    </option>
                ))}
            </select>

            {/* Arrow */}
            <ChevronDownIcon
                className="absolute w-5 h-5 -translate-y-1/2 pointer-events-none end-3 top-1/2 text-text-muted-light dark:text-text-muted-dark"
            />
        </div>
    );
};

export default SelectField;
